import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import DetailItemPriceContainer from 'app/containers/Marketing/PricingManagement/DetailItemPrice'

const DetailItemPricePageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.detail_item_price)}</PageTitle>
      <DetailItemPriceContainer />
    </>
  )
}
const DetailItemPricePage = memo(DetailItemPricePageCpn, isEqual)

export default DetailItemPricePage
